module.exports = __webpack_public_path__ + "media/images/avatar/17-22628fa0963926086e0432c6abc9079e.svg";